/**
 * Enable all accordions that exist in the DOM at page load.
 */
H_Tools?.accordions?.enableAccordions(document);
H_Tools?.accordions?.restoreAccordionState(document);

/**
 * Listen for hash changes to allow animation/scrolling on manual change.
 */
window.addEventListener('hashchange', () => {
    H_Tools?.accordions?.handleAnchorLinks(document, true);
});
